import Resource from '@/api/Resource';
import Room from '@/models/Room';

const basePermissions = [
  // Routes:
  'app.tests',
];
const adminPermissions = [
  // Routes:
  'tasks',
  'control.users',
  'docs',
  'control.tests',
  'control.reports',
  'docs.view.read',
  'docs.view.comments',
  'docs.view.edit',
  'docs.view.task',
  'control.settings',

  // Models:
  'Docs:create',
];
class User extends Resource {
  $name = 'users';

  $defaults() {
    return {
      id: null,
      status: 1,
      group_id: 2,
      email: '',
      first_name: '',
      last_name: '',
      patronymic: '',
      phone: '',
      password: '',
    };
  }

  $fill({ rooms }) {
    if (rooms) {
      this.rooms = Room.collection(rooms);
    }
  }

  get fullName() {
    return `${this.$.last_name} ${this.$.first_name} ${this.$.patronymic || ''}`.trim();
  }

  get isAdmin() {
    return this.group_id === 1;
  }

  get statusName() {
    return this.status ? 'Активен' : 'Отключен';
  }

  can(perm) {
    let permissions = this.isAdmin ? adminPermissions : basePermissions;
    return permissions.indexOf(perm) >= 0;
  }
}

export default User;
